    import React, { useEffect, useState, useRef } from "react";
    //import SearchComponent from "../Search/SearchComponent/SearchComponent";
    import { Link } from 'react-router-dom';
    //import "./gastoensalud.css";

    import { gastoenSalud } from "../../../json/gastoensalud";


    const GastoSalud = () => {
      //const [search, setSearch] = useState("");
      //const searchInput = useRef();
      require("./gastoensalud.css");
      function getFileExtension(filename) {
        if ((filename == '') || (filename == null)) {
          return 'vacio';
        } else {
          return filename.split('.').pop();
        }
      }

      function allMayus(filename) {
        if (filename == filename.toUpperCase()) {
          return true;
        } else {
          return false;
        }
      }

      function EnlacesFile(props) {
        //console.log(getFileExtension(props.enlace));
        if (getFileExtension(props.enlace) == 'xlsx') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-xls gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'pdf') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-pdf gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'docx') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-doc gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'dpdf') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-dpdf gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'dxls') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-dxls gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'ppt') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-ppt gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'zip') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-zip gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'rar') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-rar gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'jpg') {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-jpg gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        } else if (getFileExtension(props.enlace) == 'vacio') {
          return (<a className="" href="#"></a>);
        } else {
          return (<React.Fragment><div className="enlace-q text-center"><a className="archivo-url gasto-salud" href={props.enlace} target="_blank"></a>
            <p className="titulo-enlace"><small><b>{props.nomb_enlace}</b></small></p></div></React.Fragment>);
        }
      }
      const listItems = gastoenSalud.map(document =>
              <div className="col-12" key={document.item}>
               <div><br></br><br></br></div>
                <h3>{document.item}</h3>
                <div className="div-table">
                  <div className="div-table-row div-table-header m-0">
                    <div className="div-table-cell div-table-cell-concepto-header encabezado-seccion-gs bordeado-izquierdo">Documento</div>
                    <div className="div-table-cell div-table-cell-enlace-header encabezado-seccion-2-gs bordeado-derecho">Enlace</div>
                  </div>

                  {document.documento_array.map((item, index) => (
                  <div>
                    <div className={"div-table-row-padre"+" "+(((document.documento_array.length == index+1)&&(item.hasOwnProperty('hijos')==false))? "bordeado-abajo" : "")} key={item.nombre_documento}>
                      <div className="div-table-cell div-table-cell-concepto-gs">{allMayus(item.nombre_documento) ? <b>{item.nombre_documento}</b> : item.nombre_documento}</div>
                      <div className="div-table-cell div-table-cell-enlace-gs">
                        {item.documento.map((enlace, index) => (
                          <EnlacesFile
                            enlace={enlace.file_item_url}
                            nomb_enlace={enlace.file_item_nombre}
                          />
                        ))}
                      </div>
                      </div>
                      <div className="div-clear"></div>
                      <div>{(item.hijos)? item.hijos.map((hijo, index_hijo)=>(
                        <div className={"div-table-row-hijo"+" "+(((item.hijos.length == index_hijo+1)&&(document.documento_array.length == index+1))? "bordeado-abajo" : "")} key={hijo.nombre_documento}>
                             <div className="div-table-cell div-table-cell-concepto hijo">{hijo.nombre_documento}</div>
                                <div className="div-table-cell div-table-cell-enlace-gs">
                              {hijo.documento.map((enlace, index_enlace) => (
                               <EnlacesFile
                                 enlace={enlace.file_item_url}
                                 nomb_enlace={enlace.file_item_nombre}
                                />
                              ))}
                               </div>
                             <div className="div-clear"></div>
                        </div>
                        )) : null }
                      </div>
                  </div>  
                  ))}
                </div>
              </div>
            );

      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      return (

        <div className="container gastosalud-container">
          <div className="row">
            <div className="col-12">
              <div className="gasto_salud_title">
                <h1>Gasto en Salud</h1>
              </div>
            </div>
          </div>
          <div className="row w-100">
            {listItems}
          </div>
          <div><br></br><br></br></div>
        </div>
      );
    };

    export default GastoSalud;